export enum GraphEventType {
  CanvasClick = 'canvas:click',
  CanvasMouseDown = 'canvas:mouse-down',
  CanvasMouseMove = 'canvas:mouse-move',
  CanvasMouseUp = 'canvas:mouse-up',
  CanvasMouseEnter = 'canvas:mouse-enter',
  CanvasMouseLeave = 'canvas:mouse-leave',
  CanvasRightMouseDown = 'canvas:right-mouse-down',
  CanvasRightMouseUp = 'canvas:right-mouse-up',
  CanvasViewportChange = 'canvas:viewport-change',
  CanvasWheel = 'canvas:wheel',
  HoverCardMouseEnter = 'hover-card:mouse-enter',
  HoverCardMouseLeave = 'hover-card:mouse-leave',
  GraphModeChanged = 'graph:mode-changed',
  GraphDataChange = 'graph:data-change',
  NodeClick = 'node:click',
  NodeMouseDown = 'node:mouse-down',
  NodeMouseEnter = 'node:mouse-enter',
  NodeMouseMove = 'node:mouse-move',
  NodeMouseNear = 'node:mouse-near',
  NodeMouseLeave = 'node:mouse-leave',
  NodeMouseUp = 'node:mouse_up',
  NodeSelectChange = 'node-select:change',
  NodePositionChange = 'node:position-change',
  CollapsedGroupMouseEnter = 'collapsed-group:mouse-enter',
  CollapsedGroupMouseLeave = 'collapsed-group:mouse-leave',
  CollapsedGroupMouseDown = 'collapsed-group:mouse-down',
  CollapsedGroupMouseUp = 'collapsed-group:mouse-up',
  CollapsedGroupMouseMove = 'collapsed-group:mouse-move',
  CollapsedGroupPositionChange = 'collapsed-group:position-change',
  CollapsedPairwiseNodeMouseEnter = 'collapsed-pairwise-node:mouse-enter',
  CollapsedPairwiseNodeMouseLeave = 'collapsed-pairwise-node:mouse-leave',
  CollapsedPairwiseNodeMouseDown = 'collapsed-pairwise-node:mouse-down',
  CollapsedPairwiseNodeMouseUp = 'collapsed-pairwise-node:mouse-up',
  CollapsedPairwiseNodeMouseMove = 'collapsed-pairwise-node:mouse-move',
  CollapsedPairwiseNodePositionChange = 'collapsed-pairwise-node:position-change',
  GraphKeyup = 'graph:keyup',
  GraphKeydown = 'graph:keydown',
  RendererAfterAnimate = 'renderer:after-animate',
  RendererBeforeAnimate = 'renderer:before-animate',
  RendererBeforeLayoutChange = 'renderer:before-layout-change',
  RendererLayoutChange = 'renderer:layout-change',
  RendererPaint = 'renderer:paint',
  SelectionBoxMouseDown = 'selection-box:mouse-down',
  SelectionBoxMouseEnter = 'selection-box:mouse-enter',
  SelectionBoxMouseLeave = 'selection-box:mouse-leave',
  SelectionBoxMouseMove = 'selection-box:mouse-move',
  SelectionBoxMouseUp = 'selection-box:mouse-up',
  SelectionBoxPositionChange = 'selection-box:position-change',
  WindowMouseMove = 'window:mouse-move',
  WindowMouseUp = 'window:mouse-up',
}

export default abstract class GraphEvent<T extends Event> extends Event {
  raw: T;
  abstract graphTarget: unknown;

  constructor(type: string, event: T) {
    super(type);
    this.raw = event;
  }
}
